import baseRequest from './baseRequest';

// istanbul ignore next
export function getEConsent() {
  return baseRequest.get('/api/text-screens/required-blend-e-consent');
}
